module.exports = __webpack_public_path__ + "four1.jpg?f675d60b133e8d33af500fe2095d4e18";